import React, { useMemo, useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import { isArray, isNumber, isEqual } from 'lodash';
import * as Yup from 'yup';

import { Form } from '@unform/web';
import { Input } from '~/components/Form'
import { SelectDataInTable } from '~/componentslocal';
import { t, number } from '~/helpers';
import api from '~/services/api';
import { changeQuotas } from '~/store/modules/vehicleRegistration/actions';

import * as S from './styles';

export default function Cota({ board }) {
  const [itemsQuote, setItemsQuote] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exib_justificativa, setExib_justificativa] = useState('');

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.user)

  const { quotas } = useSelector((state) => state.vehicleRegistration);

  const cellsQuote = useMemo(
    () => [
      { id: 'prod_codigo', label: 'Código' },
      { id: 'prod_descricao', label: 'Produto' },
      {
        id: 'cove_cota',
        label: 'Cota',
        format: (value) => number(value, 1),
      },
      {
        id: 'cove_saldo',
        label: 'Saldo Cota',
        format: (value) => isNumber(value) ? number(value, 1) : 'A confirmar...',
      },
    ],
    []
  );

  const fieldsQuote = useMemo(
    () => [
      {
        id: 'prod_codigo',
        label: 'Produto',
        type: 'select',
        options: itemsQuote,
        disabled: true,
      },
      {
        id: 'cove_cota',
        label: 'Cota',
        type: 'number',
      },
      {
        id: 'cove_justificativa',
        label: 'justificativa',
        type: 'textarea'
      }
    ],
    [itemsQuote]
  );

  const handleValidJustificativa = useCallback((value) => {

    const regex1 = /[('")]/;

    if (regex1.test(value)) {
      return false;
    }

    return true;

  }, [])

  const schemaQuote = useMemo(
    () => ({
      prod_codigo: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      cove_cota: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      cove_justificativa: Yup.string()
        .test('Teste caracteres', 'Caractere(s) inválido(s)', (value) => handleValidJustificativa(value))
    }),
    []
  );

  const handleGetAPIPossiblesQuote = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get(`veiculo/cotas/possiveis/${board}`, {
        params: { pesquisalista: true },
      });

      setItemsQuote(
        data.map((item) => ({
          ...item,
          id: item.prod_codigo,
          label: item.prod_descricao,
          value: item.prod_codigo,
        }))
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [board]);

  const handleSerializeQuote = useCallback(
    (value) => {
      let objectSend = {
        ...itemsQuote.find((i) => i.prod_codigo === value.prod_codigo),
        ...value,
        cove_saldo: 'A confirmar',
        novo_cove_saldo: Number(value.coun_cota),
        cove_justificativa: value.cove_justificativa ?? ''
      }

      return objectSend
    },
    [itemsQuote]
  );

  const handleChangeQuotes = useCallback((values) => {
    setExib_justificativa('')
    if (!isEqual(values, quotas)) {
      toast.warn('A alteração só será salva após o clique no botão "Confirmar"')
    }
    dispatch(changeQuotas(values));
  }, [quotas]);

  useEffect(() => {
    handleGetAPIPossiblesQuote();
  }, []);

  return (
    <S.Container>
      <SelectDataInTable
        radio
        cells={cellsQuote}
        items={itemsQuote}
        fields={fieldsQuote}
        schema={schemaQuote}
        initials={quotas}
        title="Cota do Veículo"
        unique="prod_codigo"
        isIgnore="prod_codigo"
        maxWidth="xs"
        onRow={({ cove_justificativa }) => setExib_justificativa(cove_justificativa)}
        onChanged={handleChangeQuotes}
        onField={handleSerializeQuote}
        loading={loading}
        userPerfil={userInfo.profile}
        cota
      />

      {exib_justificativa && <Form>
        <Input
          name="justificativa_exib"
          label="Justificativa"
          disabled
          value={exib_justificativa}
          multiline
          rows={4}
        />
      </Form>}
    </S.Container>
  );
}

Cota.propTypes = {
  board: PropTypes.string.isRequired,
};
